/**
 * ISSUE-1393. The small "PP" badge beside a hockey team on a power play, the
 * port of v1's `power_play_badge.dart`: the server's label on the warning
 * fill, bold, one line. One width everywhere (`SCORE_ROW_POWER_PLAY_BADGE_PX`
 * minus its gap), so the score row's name arithmetic holds. Decorative: the
 * live state's own sentence ("Capitals on the power play") is what a screen
 * reader hears, so the badge is hidden from it.
 */
import { tokens } from "@sportsmet/theme";
import { cn } from "@sportsmet/ui";
import type { CSSProperties, ReactNode } from "react";

const BADGE_STYLE: CSSProperties = { width: tokens.size.iconLg };

export const PowerPlayBadge = (props: {
  label: string;
  className?: string;
}): ReactNode => (
  <span
    aria-hidden="true"
    data-testid="power-play-badge"
    style={BADGE_STYLE}
    className={cn(
      "pointer-events-none inline-flex shrink-0 items-center justify-center rounded-sm bg-warning-solid text-small font-bold italic leading-none text-on-warning",
      props.className,
    )}
  >
    {props.label}
  </span>
);
